import React from "react";
import { PencilIcon, PlusSmallIcon } from "@heroicons/react/24/solid";

const ServiceConfiguratorExpressionMarker = ({ onClick, title, setted }) => {
  return (
    <div
      onClick={onClick}
      className="mt-4 mb-4 flex items-center justify-between cursor-pointer"
    >
      <p className="font-bold">{title}</p>
      <div className="w-10 h-10 -mr-2  text-gray-400">
        {setted ? <PencilIcon /> : <PlusSmallIcon />}
      </div>
    </div>
  );
};

export default ServiceConfiguratorExpressionMarker;
